export enum CommunicationChannel {
  POST = 'POST',

  MAIL = 'MAIL',
}
